__turbopack_context__.v({
  "actions": "Home-module__g21JLG__actions",
  "brandPill": "Home-module__g21JLG__brandPill",
  "brandRow": "Home-module__g21JLG__brandRow",
  "description": "Home-module__g21JLG__description",
  "eyebrow": "Home-module__g21JLG__eyebrow",
  "heroBlock": "Home-module__g21JLG__heroBlock",
  "heroPanel": "Home-module__g21JLG__heroPanel",
  "image": "Home-module__g21JLG__image",
  "imageFrame": "Home-module__g21JLG__imageFrame",
  "inlineMeta": "Home-module__g21JLG__inlineMeta",
  "landing": "Home-module__g21JLG__landing",
  "primaryAction": "Home-module__g21JLG__primaryAction",
  "returnPill": "Home-module__g21JLG__returnPill",
  "shell": "Home-module__g21JLG__shell",
  "sideLabel": "Home-module__g21JLG__sideLabel",
  "sidePanel": "Home-module__g21JLG__sidePanel",
  "sideRow": "Home-module__g21JLG__sideRow",
  "sideValue": "Home-module__g21JLG__sideValue",
  "tertiaryAction": "Home-module__g21JLG__tertiaryAction",
  "title": "Home-module__g21JLG__title",
  "visualPanel": "Home-module__g21JLG__visualPanel",
});
